import {Injectable} from '@angular/core';
import {HttpHeaders} from '@angular/common/http';
import {HttpClient} from '@angular/common/http';
import {WebService} from '../web/web.service';
import {SessionStoreService} from '../session-store.service';


@Injectable({
  providedIn: 'root'
})
export class AuthService {

  httpOptions : any;

  APP_USER_TIME = "TIME_USER";
  APP_TIME_SESSION = 10;

    constructor(private sessionStore: SessionStoreService) {
    }

    // PARA VERIFICAR SESION
    public isLoggedIn(): Boolean {
        return this.sessionStore.getSesion() != null;
    }

    // PARA CERRAR SESION
    public closeSesion(): void {
        this.sessionStore.clear();
        localStorage.clear();
    }

}
